// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"kQ-z","categoryName":"lQ-z","categoryNameSearchHeader":"mQ-z","categoryContent":"nQ-z","bottomAligned":"oQ-z","image":"pQ-z","imageNoBackground":"qQ-z"};